import request from '@/utils/request'
import { HOST, APPS, SERVICES, OPERATIONS } from './config'

export const host = HOST

const buildURL = (app, operation, service) => {
  return `${app}/${operation}/${service}`
}

const createAPI = (serviceName, app = APPS.WS, operation = OPERATIONS.SELECT) => {
  return (data) => request({
    url: buildURL(app, operation, serviceName),
    method: 'POST',
    data
  })
}

export const websiteAPI = {
  getConfig: createAPI(SERVICES.WEBSITE_CFG),
  getCarousel: createAPI(SERVICES.CAROUSEL),
  getCategory: createAPI(SERVICES.CATEGORY),
  getContent: (data, app = APPS.WS) => createAPI(SERVICES.CONTENT, app)(data)
}

export const authAPI = {
  login: createAPI(SERVICES.LOGIN, APPS.SSO, OPERATIONS.OPERATE),
  logout: createAPI(SERVICES.LOGOUT, APPS.SSO, OPERATIONS.OPERATE),
  checkMobile: createAPI(SERVICES.CHECK_MOBILE, APPS.SSO, OPERATIONS.OPERATE),
  sendCode: createAPI(SERVICES.SEND_CODE, APPS.SSO, OPERATIONS.OPERATE),
  resetPwd: createAPI(SERVICES.RESET_PWD, APPS.SSO, OPERATIONS.OPERATE),
  userResetPwd: createAPI(SERVICES.USER_RESET_PWD, APPS.SSO, OPERATIONS.OPERATE)
}

export const memberAPI = {
  getInfo: createAPI(SERVICES.MEMBER_INFO),
  getPayInfo: createAPI(SERVICES.MEMBER_PAY)
}

export const fileAPI = {
  getInfo: createAPI(SERVICES.FILE_SELECT, APPS.FILE),
  delete: (data) => request({
    url: '/file/delete',
    method: 'POST',
    data
  })
}

export const otherAPI = {
  friendLinks: createAPI(SERVICES.FRIEND_LINKS),
  sendCode: (data, app = APPS.WS) => createAPI(SERVICES.MOBILE_NOTE_SEND, app, OPERATIONS.OPERATE)(data),
  getEventInfo: () => {
    let req = {
      "serviceName": SERVICES.EVENT_MGT,
      "colNames": ["*"],
      "condition": [],
      "page": { "pageNo": 1, "rownumber": 6 },
      "order": [{"colName":"modify_time","orderType":"asc"}]
    }
    return request({
      url: buildURL(APPS.FYZHMD, OPERATIONS.SELECT, SERVICES.EVENT_MGT),
      method: 'POST',
      data: req
    })
  },
  getCaseInfo: (app, type, srv) => {
    let req = {
      "serviceName": srv,
      "colNames": ["*"],
      "condition": [{"colName": "type", "ruleType": "eq", "value": type}],
      "page": { "pageNo": 1, "rownumber": 40 },
      "order": [{"colName":"modify_time","orderType":"asc"}]
    }
    return request({
      url: buildURL(app, OPERATIONS.SELECT, srv),
      method: 'POST',
      data: req
    })
  }
}

export const multi = (data, app) => request({
  url: `${app}/${OPERATIONS.MULTI}/${OPERATIONS.SELECT}/`,
  method: 'POST',
  data
})

export const getV2 = (data, app) => createAPI(SERVICES.COLUMNNEX_V2, app)(data)

export const setRequest = (req, type, srv, app) => request({
  url: `${app}/${type}/${srv}?${srv}`,
  method: 'POST',
  data: req
})

export function getWebSiteConfig () {
  let req = {
    "serviceName": SERVICES.WEBSITE_CFG,
    "colNames": ["*"],
    "condition": [{"colName": "website_no", "ruleType": "[like]", "value": ''}],
    "page": { "pageNo": 1, "rownumber": 999 },
    "order": []
  }
  return request({ url: buildURL(APPS.WS, OPERATIONS.SELECT, SERVICES.WEBSITE_CFG), method: 'POST', data: req })
}

export function getWebSitePcCarousel () {
  let req = {
    "serviceName": SERVICES.CAROUSEL,
    "colNames": ["*"],
    "condition": [
      {"colName": "website_no", "ruleType": "[like]", "value": ''},
      {"colName": "is_view", "ruleType": "eq", "value": '是'}
    ],
    "page": { "pageNo": 1, "rownumber": 999 },
    "treeData": true,
    "order": [{"colName":"seq","orderType":"asc"}]
  }
  return request({ url: buildURL(APPS.WS, OPERATIONS.SELECT, SERVICES.CAROUSEL), method: 'POST', data: req })
}

export function getWebSiteCategoryConfig () {
  let req = {
    "serviceName": SERVICES.CATEGORY,
    "colNames": ["*"],
    "condition": [
      {"colName": "website_no", "ruleType": "[like]", "value": ''},
      {"colName": "is_view", "ruleType": "eq", "value": '是'},
      {"colName": "website_no", "ruleType": "in","value": "PCWS202307110001" }
    ],
    "page": { "pageNo": 1, "rownumber": 999 },
    "order": [{"colName":"seq","orderType":"asc"}]
  }
  return request({ url: buildURL(APPS.WS, OPERATIONS.SELECT, SERVICES.CATEGORY), method: 'POST', data: req })
}

export function getContent (data, app) {
  let srvApp = app || APPS.WS
  return request({ url: buildURL(srvApp, OPERATIONS.SELECT, SERVICES.CONTENT), method: 'POST', data })
}

export function getListData (data, appName, serviceName) {
  return request({ url: `${host}/${appName}/select/${serviceName}?${serviceName}`, method: 'POST', data })
}

export function login (data) { return authAPI.login(data) }

export function friendLinks (data, app) { return otherAPI.friendLinks(data, app) }

export function loginOut() { return authAPI.logout([{ "serviceName": SERVICES.LOGOUT }]) }

export function getMemberInfo (data, app) { return memberAPI.getInfo(data, app) }

export function deleteFile (data) { return fileAPI.delete(data) }

export function checkMobile (data) { return authAPI.checkMobile(data) }

export function getCode (data) { return authAPI.sendCode(data) }

export function resetPwd (data) { return authAPI.resetPwd(data) }

export function userResetPwd (data) { return authAPI.userResetPwd(data) }

export function sendCode (data, app) { return otherAPI.sendCode(data, app) }

export function getCaseInfo (app, type, srv) { return otherAPI.getCaseInfo(app, type, srv) }

export function getEventInfo () { return otherAPI.getEventInfo() }

export function getFileInfo (no) {
  let req = {
    "serviceName": SERVICES.FILE_SELECT,
    "colNames": ["*"],
    "condition": [
      {"colName": "file_no", "value": no, "ruleType": "eq"},
      {"colName": "is_delete", "value": "1", "ruleType": "eq"}
    ],
    "page": { "pageNo": 1, "rownumber": 6 },
    "order": [{"colName":"modify_time","orderType":"asc"}]
  }
  return request({ url: buildURL(APPS.FILE, OPERATIONS.SELECT, SERVICES.FILE_SELECT), method: 'POST', data: req })
}

export function getPayInfo (req) { return memberAPI.getPayInfo(req) }

export const getXianZhuang = (app, type, srv) => getCaseInfo(app, type, srv)

export const getJianBao = (app, type, srv) => getCaseInfo(app, type, srv)
